import { render, staticRenderFns } from "./potentialGoods.vue?vue&type=template&id=e0116f9e&scoped=true&"
import script from "./potentialGoods.vue?vue&type=script&lang=js&"
export * from "./potentialGoods.vue?vue&type=script&lang=js&"
import style0 from "./potentialGoods.vue?vue&type=style&index=0&id=e0116f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0116f9e",
  null
  
)

component.options.__file = "potentialGoods.vue"
export default component.exports